import React, { useEffect, useState } from 'react';
import './AllProjects.css'
import SingleProject from './SingleProject/SingleProject';

const AllProjects = () => {
    let [project, setProject] = useState([])
    useEffect(()=>{
        fetch('./projects.json')
        .then(res=>res.json())
        .then(data=>{
            setProject(data)
        })
    },[])
    return (
        <div className='container mt-5'>
            <div className="main">
                  <h2 className='text-center title fw-bold font-monospace'>Recent Projects</h2>
            </div>

            <div className='row mt-4  g-4' >
              
                  {
                        project.map((item)=>{
                        return(
                            <div className='col-md-12 mx-auto pb-3' key={item.id} data-aos="fade-right" data-aos-offset="100" data-aos-easing="ease-in-sine">
                                <SingleProject projects={item}> </SingleProject>
                            </div>
                        )
                    })
                  }  
            </div>
        </div>
    );
};

export default AllProjects;